import axios from '@/utils/axios';

export type ProviderAvailability = {
  available_on_date: boolean;
  reason?: string;
  next_available_on?: string | null;
  blocked_offday?: {
    id: number;
    start_date: string | null;
    end_date: string | null;
  } | null;
  conflicting_session?: {
    session_id: number;
    start_time: string;
    end_time: string;
    date: string;
    time: string;
    timeslot?: string;
  } | null;
};

export type ProviderMatchResult = {
  provider_id: number;
  name: string;
  rating: number | null;
  match_type: 'direct' | 'nearby';
  service_types: string[];
  covered_postcodes: string[];
  nearby_postcodes: string[];
  availability: ProviderAvailability;
  assigned_bookings_at_address?: number;
};

export type ProviderMatchSearchResponse = {
  matches: ProviderMatchResult[];
  reason?: string;
};

export type ProviderMatchRequest = {
  outward_code: string;
  service_type: string;
  date?: string;
  limit?: number;
  address_id?: number;
  client_user_id?: number;
  start_time?: string;
  end_time?: string;
};

export type ProviderMatchBatchRequest = ProviderMatchRequest & {
  reference?: string;
};

export type ProviderMatchBatchResponseItem = {
  request: ProviderMatchBatchRequest;
  matches: ProviderMatchResult[];
  reason?: string;
};

export async function getProviderMatches(
  params: ProviderMatchRequest
): Promise<ProviderMatchSearchResponse> {
  const { data } = await axios.get('/providers/matches', { params });
  return data?.data ?? { matches: [] };
}

export async function getProviderMatchesBatch(
  requests: ProviderMatchBatchRequest[]
): Promise<ProviderMatchBatchResponseItem[]> {
  if (!requests.length) return [];

  const {
    data: {
      data: { results },
    },
  } = await axios.post('/providers/matches/batch', { requests });

  return results ?? [];
}
